import { useContext, useEffect, useState } from "react";
import { Typography, TextField } from "@mui/material";
import { ReportEditContext } from "../contexts/reportEdit";

// A report text node that an admin can edit in place. When not in edit mode (or
// for non-admin viewers) it renders exactly like a normal <Typography>, showing
// the curated override if one exists, otherwise the default text passed as
// children. In admin edit mode it becomes an inline textarea; edits are buffered
// locally and committed to the overlay on blur (so typing doesn't re-render the
// whole report). The Save handler blurs the active field first to flush it.
const EditableText = ({
  fieldKey,
  children,
  multiline = true,
  rows = 2,
  ...typographyProps
}) => {
  const { editing, canEdit, getText, setText } = useContext(ReportEditContext);
  const defaultText = typeof children === "string" ? children : "";
  const committed = getText(fieldKey, defaultText);
  const [local, setLocal] = useState(committed);

  useEffect(() => {
    setLocal(committed);
  }, [committed, editing]);

  if (!(editing && canEdit)) {
    return <Typography {...typographyProps}>{committed}</Typography>;
  }

  return (
    <TextField
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={() => setText(fieldKey, local, defaultText)}
      fullWidth
      multiline={multiline}
      minRows={rows}
      size="small"
      variant="outlined"
      sx={{
        backgroundColor: "#fffbe6",
        my: 0.5,
        "& textarea": { lineHeight: 1.6 },
      }}
    />
  );
};

export default EditableText;
